module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Confirma o registro do projeto de pesquisa?"
    },
    on: {
      "yes": function($event) {
        return _vm.registrarProjeto()
      }
    },
    model: {
      value: (_vm.dialogRegistro),
      callback: function($$v) {
        _vm.dialogRegistro = $$v
      },
      expression: "dialogRegistro"
    }
  }), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Confirma a devolução do projeto de pesquisa?"
    },
    on: {
      "yes": function($event) {
        return _vm.devolverProjeto()
      }
    },
    model: {
      value: (_vm.dialogDevolucao),
      callback: function($$v) {
        _vm.dialogDevolucao = $$v
      },
      expression: "dialogDevolucao"
    }
  }), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Confirma a conclusão do projeto de pesquisa?"
    },
    on: {
      "yes": function($event) {
        return _vm.concluirProjeto()
      }
    },
    model: {
      value: (_vm.dialogConclusao),
      callback: function($$v) {
        _vm.dialogConclusao = $$v
      },
      expression: "dialogConclusao"
    }
  }), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Confirma o cancelamento do projeto de pesquisa?"
    },
    on: {
      "yes": function($event) {
        return _vm.cancelarProjeto()
      }
    },
    model: {
      value: (_vm.dialogCancelamento),
      callback: function($$v) {
        _vm.dialogCancelamento = $$v
      },
      expression: "dialogCancelamento"
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "color": "white"
    }
  }, [_c('v-toolbar-title', [_vm._v("Barra do administrador")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "text-xs-right"
  }, [_c('c-tooltip-btn', {
    attrs: {
      "icon": "done_outline",
      "color": "green",
      "disabled": _vm.projeto.situacao.item != 2,
      "tooltip": "Registrar",
      "disabled-tooltip": "Apenas um projeto de pesquisa na situação \"Aguardando registro\" pode ser registrado"
    },
    on: {
      "click": function($event) {
        return _vm.goRegistrarProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "not_interested",
      "color": "red",
      "disabled": _vm.projeto.situacao.item != 2,
      "tooltip": "Devolver para o coordenador",
      "disabled-tooltip": "Apenas um projeto de pesquisa na situação \"Aguardando registro\" pode ser devolvido para o coordenador"
    },
    on: {
      "click": function($event) {
        return _vm.goDevolverProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "folder",
      "color": "brown lighten-1",
      "disabled": _vm.projeto.situacao.item != 3,
      "tooltip": "Concluir",
      "disabled-tooltip": "Apenas um projeto de pesquisa na situação \"Em andamento\" pode ser concluído"
    },
    on: {
      "click": function($event) {
        return _vm.goConcluirProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "cancel_presentation",
      "color": "red",
      "disabled": _vm.projeto.situacao.item != 3,
      "tooltip": "Cancelar",
      "disabled-tooltip": "Apenas um projeto de pesquisa na situação \"Em andamento\" pode ser cancelado"
    },
    on: {
      "click": function($event) {
        return _vm.goCancelarProjeto()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2de1575f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-barra-administrador-prppg.vue
// module id = 806
// module chunks = 0